import React, { useState, useEffect } from 'react';
import { Link } from 'react-router-dom';

const API = process.env.REACT_APP_BACKEND_URL;

function formatPrice(p) {
  if (p == null) return '0,00 €';
  return p.toLocaleString('de-DE', { minimumFractionDigits: 2, maximumFractionDigits: 2 }) + ' €';
}

export default function RecentlyViewed({ currentSlug }) {
  const [products, setProducts] = useState([]);

  useEffect(() => {
    const stored = JSON.parse(localStorage.getItem('recently_viewed') || '[]');
    const filtered = stored.filter(s => s !== currentSlug).slice(0, 6);
    if (filtered.length === 0) return;

    fetch(`${API}/api/shop/recently-viewed?slugs=${filtered.join(',')}`)
      .then(r => r.json())
      .then(d => setProducts(d.products || []))
      .catch(() => {});
  }, [currentSlug]);

  // Track current product
  useEffect(() => {
    if (!currentSlug) return;
    const stored = JSON.parse(localStorage.getItem('recently_viewed') || '[]');
    const updated = [currentSlug, ...stored.filter(s => s !== currentSlug)].slice(0, 10);
    localStorage.setItem('recently_viewed', JSON.stringify(updated));
  }, [currentSlug]);

  if (products.length === 0) return null;

  return (
    <section className="rv-section" data-testid="recently-viewed">
      <h3 className="rv-title">Zuletzt angesehen</h3>
      <div className="rv-grid">
        {products.map(p => (
          <Link to={`/p/${p.slug}`} key={p.alias} className="rv-card" data-testid={`rv-${p.alias}`}>
            <div className="rv-img">
              {p.image_url_full ? <img src={p.image_url_full} alt={p.name} loading="lazy" /> : <div className="rv-noimg" />}
            </div>
            <span className="rv-name">{p.name}</span>
            <span className="rv-price">{formatPrice(p.price)}</span>
          </Link>
        ))}
      </div>
    </section>
  );
}
